// extracted by mini-css-extract-plugin
export default {"progress":"ProgressBar_progress_iOqmb","segment":"ProgressBar_segment_mPd9q","active":"ProgressBar_active_rKif6"};